import { render, staticRenderFns } from "./planItem.vue?vue&type=template&id=2f2e97f2"
import script from "./planItem.vue?vue&type=script&lang=js"
export * from "./planItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2e97f2')) {
      api.createRecord('2f2e97f2', component.options)
    } else {
      api.reload('2f2e97f2', component.options)
    }
    module.hot.accept("./planItem.vue?vue&type=template&id=2f2e97f2", function () {
      api.rerender('2f2e97f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/plan/planItem.vue"
export default component.exports